import React, { useState } from "react";
import { MdOutlineFileUpload } from "react-icons/md";
import reconciliationDone from "../../../../assets/reconciliationDone2.svg";
import { read, utils } from "xlsx";
import Papa from "papaparse";
import { useEffect } from "react";
import axios from "axios";
import { BASE_URL, CustomTablePagination } from "../../../../Utlils";
import { useParams } from "react-router-dom";
import { useGlobalContext } from "../../../../Contexts/GlobalContext";
import { RiFileExcel2Line } from "react-icons/ri";
import { TbFileTypeCsv } from "react-icons/tb";
import NoData from "../../../../components/NoData";
import { useQuery } from "@tanstack/react-query";
import { FcExpired } from "react-icons/fc";
const Reconciliation = ({ singleSurveyStats, getSingleSurvey }) => {
  const { id } = useParams();
  const [page, setPage] = useState(0);
  const {
    data: isReconciliationTimeExpired,
    isLoading: isReconciliationTimeExpiredLoading,
    isError: isReconciliationTimeExpiredError,
  } = useQuery({
    queryFn: () => getLastCompleteDate(id),
    queryKey: ["lastComplete", id],
    staleTime: 10000,
    cacheTime: 15000,
  });
  const [reconciledTable, setReconciledTable] = useState({
    loading: true,
    data: [],
    error: false,
  });
  const [reconcilationChange, setReconcilationChange] = useState({});
  const [reconcilationStats, setReconcilationStats] = useState({
    completedIDs: 0,
    approvedIDs: 0,
    rejectedIDs: 0,
    nonReconciledIDs: 0,
    uploadedIDs: 0,
    matchedIDs: 0,
    totalApprovedIDs: 0,
    totalRejectedIDs: 0,
  });
  const { setSnackbar } = useGlobalContext();
  const [error, setError] = useState({
    type: "",
    file: "",
  });
  const [paginationPage, setPaginationPagePage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // pagination function
  const handleChangePage = (event, newPage) => {
    setPaginationPagePage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPaginationPagePage(0);
  };

  //READ EXCEL FILE:
  const readExcelFile = async (data) => {
    const workbook = read(data, { type: "binary" });
    const sheetName = workbook.SheetNames[0];
    const sheet = workbook.Sheets[sheetName];
    const jsonData = utils.sheet_to_json(sheet);
    return jsonData;
  };

  //READ CSV:
  const readCSVFile = async (data) => {
    return new Promise((resolve, reject) => {
      Papa.parse(data, {
        header: true,
        dynamicTyping: true,
        complete: (result) => {
          resolve(result.data);
        },
        error: (error) => {
          console.error("Error parsing CSV:", error.message);
          reject(error);
        },
      });
    });
  };

  //HANDLE RECONCILATION FILE:
  const [fileData, setFileData] = useState([]);
  const handleReconciliation = async () => {
    const file = reconcilationChange?.reconcilationFile;
    if (!reconcilationChange?.type) {
      setError((prev) => ({ ...prev, type: "Please Select Type!" }));
      return;
    }
    if (!reconcilationChange?.reconcilationFile) {
      setError((prev) => ({ ...prev, file: "Please Upload File!" }));
      return;
    }

    if (file) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        const data = e.target.result;
        let readData = [];

        if (file.name.endsWith(".xlsx")) {
          readData = await readExcelFile(data);
        } else {
          readData = await readCSVFile(data);
        }
        // Detect the column with data
        const columnWithData = Object.keys(readData[0] || {}).find(
          (key) => readData[0][key] !== null && readData[0][key] !== undefined
        );
        if (columnWithData) {
          const processedData = readData
            .map((obj) => obj[columnWithData])
            .filter((value) => value !== null);
          setFileData(processedData);
          setPage(1);
        } else {
          setError((prev) => ({
            ...prev,
            file: "No valid data found in the file!",
          }));
        }
      };

      reader.readAsBinaryString(file);
    }
  };

  // GET SESSIONS:
  const [sessions, setSessions] = useState([]);
  const getSessions = async () => {
    try {
      const sessions = await axios.get(
        `${BASE_URL}/session/reconcilation-sessions?surveyID=${id}`
      );
      // console.log(sessions?.data);
      let newArr = [];
      let ExpArr = [];
      sessions?.data?.forEach((d) => {
        if (checkReconciliationTimeExpired(d?.createdAt)) {
          ExpArr.push(d?.ref_id);
        } else {
          newArr.push(d);
        }
      });
      setSessions(newArr);
      setReconcilationStats((prev) => ({ ...prev, expiredIds: ExpArr }));
    } catch (error) {
      // console.log(error);
    }
  };
  async function getSurveyReconciledData(id) {
    try {
      setReconciledTable((prev) => ({ ...prev, loading: true }));
      let data = await axios.get(`${BASE_URL}/session/reconciliation/${id}`);
      setReconciledTable((prev) => ({
        ...prev,
        loading: false,
        data: data.data,
      }));
    } catch (error) {
      setReconciledTable((prev) => ({ ...prev, loading: false, error: true }));
      console.log("error in getSurveyReconciledData", error?.message);
    }
  }
  function checkReconciliationTimeExpired(dateString) {
    const inputDate = new Date(dateString);
    const currentDate = new Date();
    const timeDifference = currentDate - inputDate;
    const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
    return daysDifference > 55;
  }
  const getLastCompleteDate = async (id) => {
    try {
      let data = await axios.get(
        `${BASE_URL}/session/last-complete-date/${id}`
      );
      let { date } = data?.data;
      if (date) {
        return checkReconciliationTimeExpired(date);
      } else {
        return false;
      }
    } catch (error) {
      console.log("Unable to get last complete date");
      throw error;
    }
  };
  useEffect(() => {
    if (page == 1) getSessions();
    getSurveyReconciledData(id);
  }, [page, id]);

  //GET RECONCILATION STATS:
  const getReconcilationStats = async () => {
    let matchedIDs = [];
    let totalApprovedIDs = [];
    let totalRejectedIDs = [];
    let unmatchedIDs = [...sessions.map((session) => session.ref_id)];

    sessions?.forEach((data) => {
      if (fileData?.includes(data?.ref_id)) {
        matchedIDs.push(data?.ref_id);
        unmatchedIDs = unmatchedIDs.filter((id) => id !== data.ref_id);
        if (
          reconcilationChange?.type === "approved" &&
          !data?.reconciled?.isReconciled
        ) {
          totalApprovedIDs.push(data?.ref_id);
        } else if (
          reconcilationChange?.type === "rejected" &&
          !data?.reconciled?.isReconciled
        ) {
          totalRejectedIDs.push(data?.ref_id);
        }
      }
    });

    if (reconcilationChange?.restIDs) {
      if (reconcilationChange?.type === "approved") {
        totalRejectedIDs = unmatchedIDs;
      } else if (reconcilationChange?.type === "rejected") {
        totalApprovedIDs = unmatchedIDs;
      }
    }

    setReconcilationStats((prev) => ({
      ...prev,
      completedIDs: sessions?.filter((data) => data?.client_status === 10),
      approvedIDs: sessions?.filter(
        (data) => data?.reconciled?.reconciliationStatus === "approved"
      ),
      rejectedIDs: sessions?.filter(
        (data) => data?.reconciled?.reconciliationStatus === "rejected"
      ),
      nonReconciledIDs: sessions?.filter(
        (data) => data?.reconciled?.isReconciled === false
      ),
      uploadedIDs: fileData,
      matchedIDs: matchedIDs,
      totalApprovedIDs: totalApprovedIDs,
      totalRejectedIDs: totalRejectedIDs,
      totalCompletes: sessions?.length,
    }));
  };

  useEffect(() => {
    getReconcilationStats();
  }, [sessions?.length]);

  const approveReconcilation = async (e) => {
    try {
      const updateSessions = async (ids, isReconciled, status) => {
        return Promise.all(
          ids.map(async (id) => {
            await axios.put(`${BASE_URL}/session/update-session?refID=${id}`, {
              reconciled: {
                isReconciled: true,
                reconciliationDate: new Date(),
                reconciliationStatus: status,
              },
            });
          })
        );
      };

      if (reconcilationChange?.type === "approved") {
        await updateSessions(
          reconcilationStats?.totalApprovedIDs,
          true,
          "approved"
        );
        if (reconcilationChange?.restIDs) {
          const remainingIDs = sessions
            .filter(
              (se) =>
                !reconcilationStats?.totalApprovedIDs.includes(se?.ref_id) &&
                se?.reconciled?.isReconciled === false
            )
            .map((se) => se?.ref_id);
          await updateSessions(remainingIDs, false, "rejected");
        }
      } else if (reconcilationChange?.type === "rejected") {
        await updateSessions(
          reconcilationStats?.totalRejectedIDs,
          false,
          "rejected"
        );

        if (reconcilationChange?.restIDs) {
          const remainingIDs = sessions
            .filter(
              (se) =>
                !reconcilationStats?.totalRejectedIDs.includes(se?.ref_id) &&
                se?.reconciled?.isReconciled === false
            )
            .map((se) => se?.ref_id);
          await updateSessions(remainingIDs, true, "approved");
        }
      }

      if (
        reconcilationStats?.completedIDs?.length ==
        Number(reconcilationStats?.totalApprovedIDs?.length || 0) +
          Number(reconcilationStats?.totalRejectedIDs?.length || 0)
      ) {
        await axios.put(`${BASE_URL}/survey?id=${id}`, {
          surveyStatus: "billed",
        });
        await getSingleSurvey(id);
      }
      setSnackbar({
        msg: "Uploaded Reconcilation!",
        open: true,
        severity: "success",
      });
      setPage(3);
    } catch (error) {
      console.log(error);
    }
  };
  // console.log("reconciledTable=>", reconciledTable);
  // console.log("sessions=>", sessions);
  // console.log("reconcilationStats=>", reconcilationStats);
  return (
    <>
      {isReconciliationTimeExpiredLoading ? (
        <div className="min-h-[70vh] flex items-center justify-center">
          <h1 className="text-[14px] font-[400] text-[#666]">Loading...</h1>
        </div>
      ) : page === 0 ? (
        <div className="w-full flex flex-col gap-6">
          {/* Header */}
          <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
            <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
              Reconciliation
            </h1>
            <p className="text-[#666] text-[14px] font-[400]">
              Review and reconcile survey completes
            </p>
          </div>

          {/* Overview Stats */}
          <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-6">
            <h1 className="text-[#333] font-[500] text-[16px] mb-4">
              Overview
            </h1>
            <div className="grid grid-cols-3 gap-4">
              <div className="border-l-2 border-[#0226BE] pl-4">
                <h1 className="text-[14px] text-[#666] font-[400] mb-1">
                  Total Completes
                </h1>
                <p className="text-[#333] font-[600] text-[20px]">
                  {singleSurveyStats?.completed || 0}
                </p>
              </div>
              <div className="border-l-2 border-[#0226BE] pl-4">
                <h1 className="text-[14px] text-[#666] font-[400] mb-1">
                  Total Approved
                </h1>
                <p className="text-[#333] font-[600] text-[20px]">
                  {reconciledTable?.data?.filter(
                    (d) =>
                      d?.reconciled?.reconciliationStatus?.toLowerCase() ==
                      "approved"
                  )?.length || 0}
                </p>
              </div>
              <div className="border-l-2 border-[#0226BE] pl-4">
                <h1 className="text-[14px] text-[#666] font-[400] mb-1">
                  Total Rejected
                </h1>
                <p className="text-[#333] font-[600] text-[20px]">
                  {reconciledTable?.data?.filter(
                    (d) =>
                      d?.reconciled?.reconciliationStatus?.toLowerCase() ==
                      "rejected"
                  )?.length || 0}
                </p>
              </div>
            </div>
          </div>
          {isReconciliationTimeExpired ? (
            <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-8 min-h-[50vh] flex items-center justify-center">
              <div className="max-w-lg text-center space-y-4">
                <div className="flex items-center justify-center">
                  <FcExpired size={80} />
                </div>
                <h1 className="text-[20px] text-[#333] font-[500]">
                  Reconciliation Window Closed
                </h1>
                <p className="text-[#666] text-[14px]">
                  The deadline for reconciling completes for this survey has
                  passed. Unfortunately, you are no longer able to reconcile
                  completes for this survey.
                </p>
                <p className="text-[#666] text-[14px]">
                  If you have any questions or need assistance, please contact
                  our{" "}
                  <a
                    href="mailto:diysupport@miratsinsights.com"
                    className="text-[#0226BE] hover:underline"
                  >
                    support team.
                  </a>
                </p>
              </div>
            </div>
          ) : singleSurveyStats?.completed > reconciledTable?.data?.length ||
            reconciledTable?.data?.length == 0 ? (
            <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-6 flex flex-col gap-6">
              <h1 className="text-[#333] font-[500] text-[18px]">
                Setup Reconciliation
              </h1>
              <div className="flex flex-col gap-4">
                <div className="flex flex-col gap-2">
                  <label className="text-[#666] font-[500] text-[14px]">
                    Reconciliation File Example
                  </label>
                  <div className="flex gap-3">
                    <a
                      href="https://firebasestorage.googleapis.com/v0/b/diyprojectsample.appspot.com/o/reconciliation-example-files%2FReconcilationDemoXLSX.xlsx?alt=media&token=bdb87370-2ebe-482c-9224-3a5f8ed829bb"
                      className="p-3 border border-[#E0E0E0] rounded-md flex items-center justify-center gap-2 hover:border-[#0226BE] transition-colors"
                      download
                    >
                      <RiFileExcel2Line className="text-green-600" size={24} />
                      <span className="text-[12px] text-[#666]">Excel</span>
                    </a>
                    <a
                      href="https://firebasestorage.googleapis.com/v0/b/diyprojectsample.appspot.com/o/reconciliation-example-files%2FReconcilationDemoCSV.csv?alt=media&token=0e853484-1171-4e55-8ad3-ac5db311964d"
                      className="p-3 border border-[#E0E0E0] rounded-md flex items-center justify-center gap-2 hover:border-[#0226BE] transition-colors"
                      download
                    >
                      <TbFileTypeCsv className="text-blue-600" size={24} />
                      <span className="text-[12px] text-[#666]">CSV</span>
                    </a>
                  </div>
                </div>

                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-2">
                    <label className="text-[#666] font-[500] text-[14px]">
                      Reconciliation Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="reconcilationType"
                      id="reconcilationType"
                      className="text-[#333] text-[14px] font-[400] border border-[#E0E0E0] rounded-md h-[40px] pl-3 focus:outline-none focus:ring-2 focus:ring-[#0226BE] focus:border-transparent"
                      onChange={(e) => {
                        setReconcilationChange((prev) => ({
                          ...prev,
                          type: e.target.value,
                        }));
                        setError((prev) => ({ ...prev, type: "" }));
                      }}
                    >
                      <option value="">Select Reconciliation Type</option>
                      <option value="approved">Approved Completed IDs</option>
                      <option value="rejected">Rejected Completed IDs</option>
                    </select>
                    {error?.type && (
                      <p className="text-red-500 text-[12px]">{error?.type}</p>
                    )}
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-[#666] font-[500] text-[14px]">
                      Upload File <span className="text-red-500">*</span>
                    </label>
                    <div className="border-dashed border border-[#E0E0E0] rounded-md p-4">
                      <div className="flex w-full items-center justify-between gap-4">
                        <div className="flex items-center gap-3">
                          <MdOutlineFileUpload className="text-[#0226BE]" size={24} />
                          <p className="text-[#666] font-[400] text-[13px]">
                            Supported: .xlsx, .csv (
                            <span className="text-[#0226BE] font-[500] capitalize">
                              {reconcilationChange?.type || "Select type first"}
                            </span>
                            )
                          </p>
                        </div>
                        <input
                          type="file"
                          name="uploadBTN"
                          id="uploadBTN"
                          className="hidden"
                          accept=".xlsx, .csv"
                          onChange={(e) => {
                            setReconcilationChange((prev) => ({
                              ...prev,
                              reconcilationFile: e.target.files[0],
                            }));
                            setError((prev) => ({ ...prev, file: "" }));
                          }}
                        />
                        <label
                          htmlFor="uploadBTN"
                          className="bg-[#0226BE] text-white cursor-pointer text-[12px] font-[500] py-2 px-4 rounded-md hover:bg-[#021ea8] transition-colors"
                        >
                          Browse File
                        </label>
                      </div>
                    </div>
                    {error?.file && (
                      <p className="text-red-500 text-[12px]">{error?.file}</p>
                    )}
                    <div className="border border-[#E0E0E0] rounded-md p-4 bg-gray-50">
                      <h1 className="text-[#666] font-[500] text-[12px] mb-2">
                        Instructions:
                      </h1>
                      <ul className="list-disc pl-5 text-[#666] font-[400] text-[12px] flex flex-col gap-1">
                        <li>Keep the first row empty.</li>
                        <li>Place each ID on one line. Empty lines will be ignored.</li>
                        <li>The maximum size of the file should be 1MB or less.</li>
                      </ul>
                    </div>
                  </div>

                  <div className="flex flex-col gap-2">
                    <label className="text-[#666] font-[500] text-[14px]">
                      Options
                    </label>
                    <div className="flex items-center gap-3">
                      <input
                        type="checkbox"
                        name="reject"
                        id="reject"
                        className="w-4 h-4 cursor-pointer"
                        onChange={(e) => {
                          setReconcilationChange((prev) => ({
                            ...prev,
                            restIDs: e.target.checked,
                          }));
                        }}
                      />
                      <label
                        htmlFor="reject"
                        className="text-[#333] cursor-pointer text-[13px] font-[400]"
                      >
                        Mark rest completed IDs as{" "}
                        {reconcilationChange?.type == "approved"
                          ? "Rejected"
                          : "Approved"}
                      </label>
                    </div>
                  </div>
                </div>

                <button
                  className="bg-[#0226BE] text-white py-2 px-4 rounded-md text-[14px] font-[500] hover:bg-[#021ea8] transition-colors w-fit"
                  onClick={(e) => {
                    handleReconciliation();
                  }}
                >
                  Continue
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
          {/* Reconciled Data Table */}
          <div className="w-full bg-white border border-[#E0E0E0] rounded-md overflow-hidden">
            <div className="px-6 py-4 border-b border-[#E0E0E0]">
              <h1 className="text-[#333] font-[500] text-[18px]">
                Reconciled Data
              </h1>
            </div>
            <div className="w-full overflow-x-auto containerScroll">
              <table className="whitespace-nowrap text-left w-full">
                <thead className="h-[50px] bg-gray-50 border-b border-[#E0E0E0]">
                  <tr>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Ref ID
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Reconciliation Date
                    </th>
                    <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                      Reconciliation Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {reconciledTable?.loading ? (
                    <tr>
                      <td
                        colSpan="3"
                        className="text-center text-[14px] text-[#666] h-[155px]"
                      >
                        Loading...
                      </td>
                    </tr>
                  ) : reconciledTable?.error ? (
                    <tr>
                      <td
                        colSpan="3"
                        className="text-center text-[14px] text-red-500 h-[155px]"
                      >
                        Something went wrong while fetching the data...
                      </td>
                    </tr>
                  ) : reconciledTable?.data?.length ? (
                    (rowsPerPage > 0
                      ? reconciledTable?.data?.slice(
                          paginationPage * rowsPerPage,
                          paginationPage * rowsPerPage + rowsPerPage
                        )
                      : reconciledTable?.data
                    )?.map((d, key) => (
                      <tr
                        key={key}
                        className="border-b border-[#E0E0E0] transition-colors cursor-pointer hover:bg-blue-50/30"
                      >
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {d?.ref_id}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px]">
                          {new Date(
                            d?.reconciled?.reconciliationDate
                          )?.toLocaleDateString("en-in", {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          })}
                        </td>
                        <td className="px-4 py-4 text-[#333] font-[400] text-[13px] capitalize">
                          {d?.reconciled?.reconciliationStatus}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3}>
                        <div className="py-10">
                          <NoData />
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <CustomTablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  35,
                  { label: "All", value: -1 },
                ]}
                sx={{ fontSize: "10px" }}
                count={reconciledTable?.data.length}
                rowsPerPage={rowsPerPage}
                page={paginationPage}
                componentsProps={{
                  select: {
                    "aria-label": "rows per page",
                  },
                  actions: {
                    showFirstButton: true,
                    showLastButton: true,
                  },
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>
          </div>
        </div>
      ) : page === 1 ? (
        <div className="w-full flex flex-col gap-6">
          {/* Header */}
          <div className="w-full py-4 px-6 bg-white border-b border-[#E0E0E0]">
            <h1 className="text-[#0226BE] text-[24px] font-[500] mb-1">
              Review Reconciliation
            </h1>
            <p className="text-[#666] text-[14px] font-[400]">
              Review the reconciliation summary before approving
            </p>
          </div>

          <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-6 flex flex-col gap-6">
            <div className="grid grid-cols-2 gap-6">
              <div className="flex flex-col gap-4">
                <h2 className="text-[#333] font-[500] text-[16px]">Current Status</h2>
                <div className="border border-[#E0E0E0] rounded-md overflow-hidden">
                  <table className="w-full text-left">
                    <thead className="h-[40px] bg-gray-50 border-b border-[#E0E0E0]">
                      <tr>
                        <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                          Total
                        </th>
                        <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                          Number Of IDs
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="border-b border-[#E0E0E0]">
                        <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                          Total IDs Completed
                        </td>
                        <td className="px-4 text-[#333] font-[600] text-[14px]">
                          {reconcilationStats?.completedIDs?.length}
                        </td>
                      </tr>
                      <tr className="border-b border-[#E0E0E0]">
                        <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                          Total IDs Approved
                        </td>
                        <td className="px-4 text-[#333] font-[600] text-[14px]">
                          {reconcilationStats?.approvedIDs?.length}
                        </td>
                      </tr>
                      <tr className="border-b border-[#E0E0E0]">
                        <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                          Total IDs Rejected
                        </td>
                        <td className="px-4 text-[#333] font-[600] text-[14px]">
                          {reconcilationStats?.rejectedIDs?.length}
                        </td>
                      </tr>
                      <tr className="border-b border-[#E0E0E0]">
                        <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                          Total IDs Not-Reconciled
                        </td>
                        <td className="px-4 text-[#333] font-[600] text-[14px]">
                          {reconcilationStats?.nonReconciledIDs?.length}
                        </td>
                      </tr>
                      {reconcilationStats?.expiredIds?.length > 0 && (
                        <tr>
                          <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                            Expired Ids
                          </td>
                          <td className="px-4 text-[#333] font-[600] text-[14px]">
                            {reconcilationStats?.expiredIds?.length}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="flex flex-col gap-4">
                  <h2 className="text-[#333] font-[500] text-[16px]">Upload Summary</h2>
                  <div className="border border-[#E0E0E0] rounded-md overflow-hidden">
                    <table className="w-full text-left">
                      <thead className="h-[40px] bg-gray-50 border-b border-[#E0E0E0]">
                        <tr>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Total
                          </th>
                          <th className="text-[#666] text-[13px] font-[500] px-4 text-start">
                            Number Of IDs
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="border-b border-[#E0E0E0]">
                          <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                            Total IDs Uploaded
                          </td>
                          <td className="px-4 text-[#333] font-[600] text-[14px]">
                            {reconcilationStats?.uploadedIDs?.length}
                          </td>
                        </tr>
                        <tr className="border-b border-[#E0E0E0]">
                          <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                            Total IDs Matched
                          </td>
                          <td className="px-4 text-[#333] font-[600] text-[14px]">
                            {reconcilationStats?.matchedIDs?.length}
                          </td>
                        </tr>
                        <tr className="border-b border-[#E0E0E0]">
                          <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                            Total IDs to Approve
                          </td>
                          <td className="px-4 text-[#333] font-[600] text-[14px]">
                            {reconcilationStats?.totalApprovedIDs?.length}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-3 px-4 text-[#333] text-[14px] font-[400]">
                            Total IDs to Reject
                          </td>
                          <td className="px-4 text-[#333] font-[600] text-[14px]">
                            {reconcilationStats?.totalRejectedIDs?.length}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <p className="text-[13px] text-[#666] font-[400] pt-4 border-t border-[#E0E0E0]">
                By approving this reconciliation, you agree to our{" "}
                <span className="text-[#0226BE] hover:underline cursor-pointer">
                  reconciliation policies
                </span>
                . In case of any help, please reach out to us at{" "}
                <a
                  href="mailto:reconciliation_support@miratsquanto.com"
                  className="text-[#0226BE] hover:underline"
                >
                  reconciliation_support@miratsquanto.com
                </a>
              </p>

              <div className="flex items-center gap-3 pt-2">
                <button
                  className="border border-[#0226BE] text-[#0226BE] py-2 px-4 text-[14px] font-[500] rounded-md hover:bg-[#0226BE] hover:text-white transition-colors"
                  onClick={(e) => {
                    setReconcilationChange({});
                    setReconcilationStats({
                      completedIDs: 0,
                      approvedIDs: 0,
                      rejectedIDs: 0,
                      nonReconciledIDs: 0,
                      uploadedIDs: 0,
                      matchedIDs: 0,
                      totalApprovedIDs: 0,
                      totalRejectedIDs: 0,
                    });
                    setFileData([]);
                    setSessions([]);
                    setPage(0);
                  }}
                >
                  Upload New File
                </button>
                <button
                  className="bg-[#0226BE] text-white py-2 px-4 text-[14px] font-[500] rounded-md hover:bg-[#021ea8] transition-colors"
                  onClick={(e) => {
                    approveReconcilation(e);
                  }}
                >
                  Approve Reconciliation
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="w-full bg-white border border-[#E0E0E0] rounded-md p-8 flex flex-col items-center justify-center min-h-[60vh]">
          <div className="max-w-lg flex flex-col items-center gap-6 text-center">
            <img
              src={reconciliationDone}
              alt="reconciliationDone"
              className="w-[280px] h-[280px]"
            />
            <h1 className="text-[#333] font-[500] text-[20px]">Thank You</h1>
            <div className="flex flex-col gap-4">
              <p className="text-[#666] text-[14px]">
                Thank you for submitting the data with us. Our team will
                review the data and will accommodate your request, in case of
                any queries, we will reach out to you at your registered email
                ID.
              </p>
              <p className="text-[#666] text-[14px]">
                This will usually take 1-3 business days.
              </p>
              <p className="text-[#0226BE] font-[500] mt-2">~ Mirats Team</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Reconciliation;
